module.exports = __webpack_public_path__ + "img/img_zixun_toutu@2x.69e9eaad.png";